import axios from "axios";
import config from "../../config/local-config";
import apiConfig from "../../config/api-config";
import dateFormat from "./dateFormat";

const getOrderDetails = (accessTokenObj, orderId, breakSetKit = null, breakReturns = null) => {
  const version = "v1";
  const serviceName = "accounts";
  const iat = dateFormat;
  const site = `${config.hydra.site}`;
  const apiUrl = `${apiConfig.apiURL}/${version}/${serviceName}/order-details?`;
  let enableSetKit = config.orderDetailsBreakSetKit || 0;
  let enableReturnRequests = config.orderDetailsBreakReturnRequests || 0;

  if (breakSetKit !== null) {
    enableSetKit = breakSetKit ? 1 : 0;
  }

  if (breakReturns !== null)  {
    enableReturnRequests = breakReturns ? 1 : 0;
  }

  let body = {
    domain: site,
    customerId: accessTokenObj.customer_id,
    iat: iat,
    orderId: orderId,
    brsetkit: enableSetKit,
    brreturns: enableReturnRequests,
  };

  return axios.get(apiUrl, {
    params: body,
    headers: {
      apikey: apiConfig.apiKey,
      accessToken: accessTokenObj.access_token,
    }
  });
};
export default getOrderDetails;
